import { AppModule } from 'app/module';
import { JobAlarmEmptyStateForm } from 'module/jobAlarmEmptyStateForm/main';
import { ResultState } from 'module/resultState/main';
import { JobMatchingEmptyStateForm } from 'module/jobMatchingEmptyStateForm/main';
import { FaqList } from 'module/faqList/main';
import { MasterLayout } from 'layout/master/main';
import { user } from 'app/user';
import * as jobAlarmResultState from 'util/jobAlarmResultStates';
import * as jobMatchingResultStates from 'util/jobMatchingResultStates';
import Template from './template.hbs';
import './styles.scss';

export class EmptyState extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    ready() {
        if (this.jobAlarmEmptyStateForm?.jobsFilter) {
            this.jobAlarmEmptyStateForm.jobsFilter.loadFilterMarkup();
        }
    }

    domBindings() {
        return {
            emptyStateContainer: '.m-emptyState__container',
            emptyStateForm: '.m-emptyState__jobAlarmEmptyStateForm .m-jobAlarmEmptyStateForm',
            resultState: '.m-emptyState__resultState .m-resultState__resultContainer',
            faqList: '.m-faqList',
            jobAlarmEmptyStateForm: '.m-emptyState__jobAlarmEmptyStateForm .m-jobAlarmEmptyStateForm',
            jobMatchingEmptyStateForm: '.m-emptyState__jobMatchingEmptyStateForm .m-jobMatchingEmptyStateForm',
        };
    }

    getPropsFromDom() {
        const resultStateProps = this.resultState ? this.resultState.getPropsFromDom() : false;

        return {
            active: !!this.dom.emptyStateContainer,
            resultState: resultStateProps,
        };
    }

    subs() {
        this.layout = new MasterLayout(document.documentElement);

        if (this.dom.jobAlarmEmptyStateForm) {
            this.jobAlarmEmptyStateForm = new JobAlarmEmptyStateForm(this.dom.jobAlarmEmptyStateForm);
        }
        if (this.dom.jobMatchingEmptyStateForm) {
            this.jobMatchingEmptyStateForm = new JobMatchingEmptyStateForm(this.dom.jobMatchingEmptyStateForm);
        }
        if (this.dom.resultState) {
            this.resultState = new ResultState(this.dom.resultState);
        }

        if (this.dom.faqList) {
            this.faqList = new FaqList(this.dom.faqList);
        }
    }

    subEvents() {
        if (this.jobAlarmEmptyStateForm) {
            this.jobAlarmEmptyStateForm.events.on('createJobAlarmFailure', (e) => {
                const error = e.arguments[0].error?.general;
                if (error?.[0].jobalarm_exists) {
                    this.updateProps({
                        resultState: jobAlarmResultState.alreadyExists(),
                    }, true);
                } else if (error?.[0].jobalarm_limit_exceeded) {
                    this.updateProps({
                        resultState: jobAlarmResultState.limitExceeded(),
                    }, true);
                }
            });

            this.jobAlarmEmptyStateForm.events.on('createJobAlarmSuccess', (e) => {
                const { emailUnconfirmed, email, jobAlarmId, jobAlarmMailDaily } = e.arguments[0];
                let resultState;
                if (emailUnconfirmed) {
                    resultState = jobAlarmResultState.checkMail();
                } else if (!user.isLoggedIn()) {
                    resultState = jobAlarmResultState.success(email, jobAlarmId, jobAlarmMailDaily);
                }

                this.updateProps({
                    resultState,
                }, true);
            });
        }

        if (this.jobMatchingEmptyStateForm) {
            this.jobMatchingEmptyStateForm.events.on('createMatchingFailure', (e) => {
                const error = e.arguments[0].error?.general;
                let resultState;
                if (error?.[0].user_has_profile_without_subscription) {
                    resultState = jobMatchingResultStates.alreadyExists();
                } else if (error?.[0].user_has_profile_with_subscription) {
                    resultState = jobMatchingResultStates.alreadySubscribed();
                } else {
                    return;
                }

                this.updateProps({
                    resultState,
                }, true);
            });

            this.jobMatchingEmptyStateForm.events.on('showSuccessState', () => {
                const resultState = jobMatchingResultStates.success();
                this.updateProps({
                    resultState,
                }, true);
            });
        }
    }
}
